import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
const pageContainerStyle = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  height: "80vh",
  backgroundColor: "black",
};

const pageContentStyle = {
  width: "400px",
  backgroundColor: "black",
  padding: "30px",
  borderRadius: "8px",
  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
  textAlign: "center",
};

const commissionRowStyle = {
  display: "flex",
  alignItems: "flex-start",
  justifyContent: "space-between",
  marginBottom: "30px",
};

const labelStyle = {
  color: "#DFBD69",
  fontWeight: "600",
  fontSize: "18px",
  minWidth: "140px",
  textAlign: "left",
};

const buttonContainerStyle = {
  display: "flex",
  flexDirection: "column",
  gap: "15px",
};

const horizontalButtonContainerStyle = {
  display: "flex",
  flexDirection: "column", // Changed to column to stack vertically
  gap: "15px",
  alignItems: "center",
};
const buttonStyle = {
  backgroundColor: "#DFBD69",
  color: "black",
  border: "none",
  borderRadius: "8px",
  padding: "15px 0",
  cursor: "pointer",
  fontSize: "18px",
  width: "220px",
  fontWeight: "400",
  boxSizing: "border-box",
};

const valueStyle = {
  color: "#DFBD69",
  fontWeight: "400",
  fontSize: "16px",
  marginTop: "8px",
  marginBottom: "8px",
  textAlign: "left",
};

const confirmCancelRowStyle = {
  display: "flex",
  flexDirection: "row",
  gap: "15px",
  alignItems: "center",
};

const inputStyle = {
  padding: "15px 10px", // Match buttonStyle padding
  fontSize: "16px",
  borderRadius: "8px", // Match buttonStyle borderRadius
  border: "1px solid #DFBD69",
  width: "240px", // Match buttonStyle width
  height: "55px", // Match buttonStyle height (15px top/bottom + fontSize)
  boxSizing: "border-box",
};

const horizontalButtonStyle = {
  backgroundColor: "#DFBD69",
  color: "black",
  border: "none",
  borderRadius: "8px",
  padding: "15px 0",
  cursor: "pointer",
  fontSize: "18px",
  width: "110px",
  fontWeight: "400",
  boxSizing: "border-box",
};

// Modal Component
const Modal = ({ message, onClose }) => (
  <div style={{
    position: "fixed",
    top: 0, left: 0, right: 0, bottom: 0,
    background: "rgba(0,0,0,0.5)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 1000
  }}>
    <div style={{
      background: "#222",
      color: "#DFBD69",
      padding: "30px",
      borderRadius: "10px",
      minWidth: "320px",
      textAlign: "center",
      boxShadow: "0 4px 16px rgba(0,0,0,0.3)"
    }}>
      <div style={{ marginBottom: "20px", fontSize: "18px" }}>{message}</div>
      <button
        style={{
          backgroundColor: "#DFBD69",
          color: "black",
          border: "none",
          borderRadius: "8px",
          padding: "10px 30px",
          cursor: "pointer",
          fontSize: "16px",
          fontWeight: "600"
        }}
        onClick={onClose}
      >
        OK
      </button>
    </div>
  </div>
);

const Commission = ({ VSTATUS, commissionCoins, gemCount, }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [convertType, setConvertType] = useState(null);
  const [convertAmount, setConvertAmount] = useState('');
  const [withdrawType, setWithdrawType] = useState(null);
  const [withdrawAmount, setWithdrawAmount] = useState('');
  const [loading, setLoading] = useState(false);

  const [modalMessage, setModalMessage] = useState('');
  const [kycId, setKycId] = useState('');
  const [walletLoading, setWalletLoading] = useState(false);
  const [hasAletaAccount, setHasAletaAccount] = useState(false);
  const userID = localStorage.getItem('userID');
  const userName = localStorage.getItem("username");

  const [showBankModal, setShowBankModal] = useState(false);
  const [bankList, setBankList] = useState([]);
  const [bankListLoading, setBankListLoading] = useState(false);
  const [selectedBankBuid, setSelectedBankBuid] = useState('');
  const [bankDropdownOpen, setBankDropdownOpen] = useState(false);
  const [bankAccountNumber, setBankAccountNumber] = useState('');
  const [bankSubmitLoading, setBankSubmitLoading] = useState(false);
  const [userBanks, setUserBanks] = useState([]);
  const [userBanksLoading, setUserBanksLoading] = useState(false);
  const [withdrawBankBuid, setWithdrawBankBuid] = useState('');

  const fetchUserBanks = useCallback(() => {
    if (!userID) return;
    setUserBanksLoading(true);
    fetch(`https://xianhefairy.com/LotusFairy_API/api/user/userbank?custId=${userID}`)
      .then((res) => res.json())
      .then((data) => setUserBanks(Array.isArray(data) ? data : []))
      .catch((err) => console.error("Error fetching user banks:", err))
      .finally(() => setUserBanksLoading(false));
  }, [userID]);

  // Load the user's registered banks when the Commission page opens
  useEffect(() => {
    fetchUserBanks();
  }, [fetchUserBanks]);

  // TODO: wire up to the real edit/delete bank API once it's available
  const handleEditBank = (bank) => {
    console.log('Edit bank:', bank);
  };

  // Check whether the user already has an Aleta wallet so the create button can be disabled
  useEffect(() => {
    if (!userID || !userName) return;
    fetch("https://xianhefairy.com/LotusFairy_API/api/User/GetProfile", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        UserName: userName,
        ID: userID,
        UserToken: "",
        Token: {
          AccessToken: "xAfhn90xflfHfd.fjldfj@fdhLXHCHchlhsdflsdfhawWFRwzxxp",
        },
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        const profile = data?.Profiles?.[0];
        if (profile && (profile.AletaMemberNo || profile.AletaAccountNo)) {
          setHasAletaAccount(true);
        }
      })
      .catch((err) => console.error("Error checking Aleta account:", err));
  }, [userID, userName]);

  let commissionTypes = [];
  if (VSTATUS === 'VVP') {
    commissionTypes = ['VVP'];
  } else if (VSTATUS === 'VP') {
    commissionTypes = ['VP'];
  } else if (VSTATUS) {
    commissionTypes = ['VVP', 'VP'];
  }

  const makeApiCall = async (amount, wdType) => {
    setLoading(true);
    try {
      const response = await fetch('https://xianhefairy.com/LotusFairy_API/api/member/CommConvertUpdate', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          CUST_ID: userID,
          amount: parseInt(amount),
          wd_type: wdType,
          update_by: userName || 'User'
        })
      });

      const data = await response.json();
      
      if (response.ok) {
        return { success: true, data };
      } else {
        return { success: false, error: data.message || 'API call failed' };
      }
    } catch (error) {
      return { success: false, error: error.message };
    } finally {
      setLoading(false);
    }
  };

  // Create a Simple Account on the Aleta affiliate system using the entered KYC ID
  // const createSimpleAccount = async (custId, idValue) => {
  //   const payload = {
  //     CustId: Number(custId) || 0,
  //     IdValue: String(idValue || custId),
  //   };

  //   try {
  //     const res = await fetch("https://XianheAletaApi/api/pa/SimpleAccount", {
  //       method: "POST",
  //       headers: { "Content-Type": "application/json" },
  //       body: JSON.stringify(payload),
  //     });

  //     const respText = await res.text();
  //     if (!res.ok) {
  //       console.error("SimpleAccount creation failed:", res.status, respText);
  //       return false;
  //     }

  //     console.log("SimpleAccount created successfully:", respText);
  //     return true;
  //   } catch (error) {
  //     console.error("Error creating SimpleAccount:", error);
  //     return false;
  //   }
  // };

  // const handleCreateWallet = async () => {
  //   if (!kycId) {
  //     setModalMessage(t('commission.kycRequired', { defaultValue: 'Please enter your KYC ID.' }));
  //     return;
  //   }
  //   setWalletLoading(true);
  //   const success = await createSimpleAccount(userID, kycId);
  //   setWalletLoading(false);
  //   if (success) {
  //     setHasAletaAccount(true);
  //   }
  //   setModalMessage(
  //     success
  //       ? t('commission.walletCreated', { defaultValue: 'Aleta wallet created successfully.' })
  //       : t('commission.walletCreateFailed', { defaultValue: 'Failed to create Aleta wallet. Please try again.' })
  //   );
  // };

  const handleConvertToGems = (type) => {
    setConvertType(type);
    setConvertAmount('');
    setWithdrawType(null);
  };

  const handleWithdrawRequest = (type) => {
    setWithdrawType(type);
    setWithdrawAmount('');
    setWithdrawBankBuid('');
    setConvertType(null);
  };

  const extractBankList = (data) => {
    const raw = data?.Banks || data?.BankList || data?.Data || (Array.isArray(data) ? data : []);
    if (!Array.isArray(raw)) return [];
    return raw.map((b) => {
      const bankName = b.Name || b.BankName || b.BANK_NAME || b.Bank_Name || b.NAME || '';
      const country = b.Country || b.COUNTRY || '';
      return {
        buid: b.Uid || b.UID || b.uid || b.Buid || '',
        name: country ? `${country} - ${bankName}` : bankName,
      };
    }).filter((b) => b.buid);
  };

  const openBankModal = async () => {
    setShowBankModal(true);
    setSelectedBankBuid('');
    setBankAccountNumber('');
    setBankDropdownOpen(false);
    setBankListLoading(true);
    try {
      const response = await fetch('https://xianhefairy.com/LotusFairy_API/api/bank/GetListBank');
      const data = await response.json();
      setBankList(extractBankList(data));
    } catch (error) {
      setBankList([]);
      setModalMessage(t('commission.bankListError', { defaultValue: 'Failed to load bank list.' }));
    } finally {
      setBankListLoading(false);
    }
  };

  const closeBankModal = () => {
    setShowBankModal(false);
    setBankDropdownOpen(false);
  };

  const handleRegisterBank = async () => {
    if (!selectedBankBuid) {
      setModalMessage(t('commission.selectBankRequired', { defaultValue: 'Please select a bank.' }));
      return;
    }
    if (!bankAccountNumber.trim()) {
      setModalMessage(t('commission.bankAccountRequired', { defaultValue: 'Please enter your bank account number.' }));
      return;
    }
    setBankSubmitLoading(true);
    try {
      const requestBody = {
        UID: '',
        Buid: selectedBankBuid,
        CustId: userID,
        BankAccount: bankAccountNumber.trim(),
      };
      // console.log('RegisterBank request body:', requestBody);
      const response = await fetch('https://xianhefairy.com/LotusFairy_API/api/User/UserBankUpdate', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestBody),
      });
      const data = await response.json();
      if (response.ok) {
        setShowBankModal(false);
        setModalMessage(data?.return_err || t('commission.bankRegisterSuccess', { defaultValue: 'Bank account registered successfully.' }));
      } else {
        setModalMessage(data?.return_err || t('commission.bankRegisterError', { defaultValue: 'Error registering bank account.' }));
      }
    } catch (error) {
      setModalMessage(t('commission.bankRegisterError', { defaultValue: 'Error registering bank account.' }));
    } finally {
      setBankSubmitLoading(false);
    }
  };

  const handleConfirmConvert = async (type) => {
    if (Number(convertAmount) > Number(commissionCoins)) {
      setModalMessage(t('commission.insufficientCommission', { defaultValue: 'Amount cannot exceed your available commission balance.' }));
      return;
    }
    const result = await makeApiCall(convertAmount, 0);

    if (result.success) {
      setModalMessage(result.data.return_err || t('commission.convertSuccess', { amount: convertAmount, type }));
      setConvertType(null);
      setConvertAmount('');
      // You might want to refresh the commission data here
    } else {
      setModalMessage(result.data?.return_err || result.error || 'Error converting coins.');
    }
  };

  const handleConfirmWithdraw = async (type) => {
    if (Number(withdrawAmount) > Number(commissionCoins)) {
      setModalMessage(t('commission.insufficientCommission', { defaultValue: 'Amount cannot exceed your available commission balance.' }));
      return;
    }
    if (!withdrawBankBuid) {
      setModalMessage(t('commission.selectBankRequired', { defaultValue: 'Please select a bank.' }));
      return;
    }
    setLoading(true);
    try {
      const response = await fetch('https://xianhefairy.com/LotusFairy_API/api/member/UserWithdrawalRequest', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          CustId: userID,
          Amount: parseInt(withdrawAmount),
          BUID: withdrawBankBuid,
        }),
      });
      const data = await response.json();
      if (response.ok) {
        setModalMessage(data?.return_err || t('commission.withdrawSuccess', { amount: withdrawAmount, type }));
        setWithdrawType(null);
        setWithdrawAmount('');
        setWithdrawBankBuid('');
        // You might want to refresh the commission data here
      } else {
        setModalMessage(data?.return_err || t('commission.withdrawError', { defaultValue: 'Error submitting withdrawal request.' }));
      }
    } catch (error) {
      setModalMessage(t('commission.withdrawError', { defaultValue: 'Error submitting withdrawal request.' }));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={pageContainerStyle}>
      <div style={pageContentStyle}>
        <div style={{ marginBottom: "30px", textAlign: "left" }}>
          {/* <div style={labelStyle}>{t('commission.kycLabel', { defaultValue: 'ID for KYC' })}</div>
          <input
            type="text"
            style={{
              ...inputStyle,
              width: "100%",
              marginTop: "8px",
              marginBottom: "12px",
              opacity: hasAletaAccount ? 0.5 : 1,
            }}
            placeholder={t('commission.enterKycId', { defaultValue: 'Enter ID' })}
            value={kycId}
            onChange={e => setKycId(e.target.value)}
            disabled={walletLoading || hasAletaAccount}
          />
          <button
            style={{
              ...buttonStyle,
              width: "100%",
              opacity: walletLoading || hasAletaAccount ? 0.5 : 1,
              cursor: hasAletaAccount ? "not-allowed" : "pointer",
            }}
            onClick={handleCreateWallet}
            disabled={walletLoading || !kycId || hasAletaAccount}
          >
            {hasAletaAccount
              ? t('commission.walletAlreadyCreated', { defaultValue: 'Wallet Already Created' })
              : walletLoading
                ? t('commission.processing')
                : t('commission.createWallet', { defaultValue: 'Create Aleta Wallet' })}
          </button> */}
          <button
            style={{
              ...buttonStyle,
              width: "100%",
              boxSizing: "border-box",
              marginTop: "12px",
            }}
            onClick={() => {
              if (userID) {
                localStorage.setItem("partnerCustId", userID);
              }
              navigate("/mainmaster");
            }}
          >
            {t('commission.partnerLink', { defaultValue: 'Partner Portal' })}
          </button>
          <button
            style={{
              ...buttonStyle,
              width: "100%",
              boxSizing: "border-box",
              marginTop: "12px",
            }}
            onClick={openBankModal}
          >
            {t('commission.registerBank', { defaultValue: 'Register Bank' })}
          </button>
          {userBanksLoading ? (
            <div style={{ ...valueStyle, marginTop: "12px" }}>
              {t('commission.loadingBanks', { defaultValue: 'Loading banks...' })}
            </div>
          ) : userBanks.length > 0 && (
            <div style={{ marginTop: "12px" }}>
              <div style={labelStyle}>{t('commission.registeredBanks', { defaultValue: 'Registered Banks' })}</div>
              <div style={{ maxHeight: "180px", overflowY: "auto" }}>
                {userBanks.map((bank) => (
                  <div key={bank.Uid} style={{ ...valueStyle, display: "flex", justifyContent: "space-between", alignItems: "center", gap: "10px" }}>
                    <span>{bank.Name}</span>
                    <span style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                      {bank.BankAccount}
                      <button
                        type="button"
                        style={{
                          background: "transparent",
                          border: "1px solid #DFBD69",
                          color: "#DFBD69",
                          borderRadius: "6px",
                          padding: "4px 10px",
                          cursor: "pointer",
                          fontSize: "13px",
                        }}
                        onClick={() => handleEditBank(bank)}
                      >
                        {t('commission.edit', { defaultValue: 'Edit' })}
                      </button>
                    </span>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
        {commissionTypes.map((type) => (
          <div key={type}>
            <h2 style={{ color: "#DFBD69" }}> {t('commission.title')}</h2>
            <div style={{
              ...commissionRowStyle,
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "center",
              gap: "30px"
            }}>
              <div style={{ minWidth: "180px", textAlign: "left" }}>
                <div style={labelStyle}>{t('commission.commissionLabel')}:</div>
                <div style={valueStyle}>US${commissionCoins}</div>
                <div style={labelStyle}>{t('commission.gemsLabel')}:</div>
                <div style={valueStyle}>{gemCount}</div>
              </div>
              <div style={convertType === type || withdrawType === type ? horizontalButtonContainerStyle : buttonContainerStyle}>
                {convertType === type ? (
                  <>
                    <input
                      type="number"
                      style={inputStyle}
                      placeholder={t('commission.enterAmount')}
                      value={convertAmount}
                      min={1}
                      max={commissionCoins}
                      onChange={e => setConvertAmount(e.target.value)}
                      disabled={loading}
                    />
                    <div style={confirmCancelRowStyle}>
                      <button
                        style={{...horizontalButtonStyle, opacity: loading ? 0.6 : 1}}
                        onClick={() => handleConfirmConvert(type)}
                        disabled={!convertAmount || convertAmount <= 0 || Number(convertAmount) > Number(commissionCoins) || loading}
                      >
                        {loading ? t('commission.processing') : t('commission.confirm')}
                      </button>
                      <button
                        style={horizontalButtonStyle}
                        onClick={() => setConvertType(null)}
                        disabled={loading}
                      >
                        {t('commission.cancel')}
                      </button>
                    </div>
                  </>
                ) : withdrawType === type ? (
                  <>
                    <select
                      style={{ ...inputStyle, width: "240px" }}
                      value={withdrawBankBuid}
                      onChange={e => setWithdrawBankBuid(e.target.value)}
                      disabled={loading}
                    >
                      <option value="">
                        {t('commission.selectBank', { defaultValue: 'Select Bank' })}
                      </option>
                      {userBanks.map((bank) => (
                        <option key={bank.Uid} value={bank.Uid}>{bank.Name} ({bank.BankAccount})</option>
                      ))}
                    </select>
                    <input
                      type="number"
                      style={inputStyle}
                      placeholder={t('commission.enterAmount')}
                      value={withdrawAmount}
                      min={1}
                      max={commissionCoins}
                      onChange={e => setWithdrawAmount(e.target.value)}
                      disabled={loading}
                    />
                    <div style={confirmCancelRowStyle}>
                      <button
                        style={{...horizontalButtonStyle, opacity: loading ? 0.6 : 1}}
                        onClick={() => handleConfirmWithdraw(type)}
                        disabled={!withdrawAmount || withdrawAmount <= 0 || Number(withdrawAmount) > Number(commissionCoins) || !withdrawBankBuid || loading}
                      >
                        {loading ? t('commission.processing') : t('commission.confirm')}
                      </button>
                      <button
                        style={horizontalButtonStyle}
                        onClick={() => setWithdrawType(null)}
                        disabled={loading}
                      >
                        {t('commission.cancel')}
                      </button>
                    </div>
                  </>
                ) : (
                  <>
                    <div style={{
                      display: "flex",
                      flexDirection: "row",
                      gap: "15px",
                      alignItems: "center"
                    }}>
                      <button 
                        style={buttonStyle} 
                        onClick={() => handleConvertToGems(type)}
                        disabled={loading}
                      >
                        {t('commission.convertToGems')}
                      </button>
                      <button 
                        style={buttonStyle} 
                        onClick={() => handleWithdrawRequest(type)}
                        disabled={loading}
                      >
                        {t('commission.requestWithdrawal')}
                      </button>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
      {modalMessage && (
        <Modal
          message={modalMessage}
          onClose={() => setModalMessage('')}
        />
      )}
      {showBankModal && (
        <div style={{
          position: "fixed",
          top: 0, left: 0, right: 0, bottom: 0,
          background: "rgba(0,0,0,0.5)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 1000
        }}>
          <div style={{
            background: "#222",
            color: "#DFBD69",
            padding: "40px",
            borderRadius: "10px",
            minWidth: "440px",
            textAlign: "center",
            boxShadow: "0 4px 16px rgba(0,0,0,0.3)"
          }}>
            <div style={{ marginBottom: "24px", fontSize: "20px", fontWeight: "600" }}>
              {t('commission.registerBankTitle', { defaultValue: 'Bank Registration' })}
            </div>
            <div style={{ position: "relative", width: "100%", marginBottom: "15px" }}>
              <button
                type="button"
                style={{
                  ...inputStyle,
                  width: "100%",
                  textAlign: "left",
                  background: "#fff",
                  color: "#000",
                  cursor: bankListLoading || bankSubmitLoading ? "not-allowed" : "pointer",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
                onClick={() => setBankDropdownOpen((open) => !open)}
                disabled={bankListLoading || bankSubmitLoading}
              >
                <span>
                  {bankListLoading
                    ? t('commission.loadingBanks', { defaultValue: 'Loading banks...' })
                    : bankList.find((b) => b.buid === selectedBankBuid)?.name
                      || t('commission.selectBank', { defaultValue: 'Select Bank' })}
                </span>
                <span>▾</span>
              </button>
              {bankDropdownOpen && (
                <>
                  <div
                    onClick={() => setBankDropdownOpen(false)}
                    style={{ position: "fixed", inset: 0, zIndex: 1050 }}
                  />
                  <div style={{
                    position: "absolute",
                    top: "100%",
                    left: 0,
                    right: 0,
                    marginTop: "4px",
                    maxHeight: "280px",
                    overflowY: "auto",
                    background: "#fff",
                    color: "#000",
                    border: "1px solid #DFBD69",
                    borderRadius: "8px",
                    zIndex: 1100,
                    boxShadow: "0 4px 16px rgba(0,0,0,0.3)",
                  }}>
                    {bankList.map((bank) => (
                      <div
                        key={bank.buid}
                        style={{ padding: "10px", cursor: "pointer", textAlign: "left" }}
                        onClick={() => {
                          setSelectedBankBuid(bank.buid);
                          setBankDropdownOpen(false);
                        }}
                      >
                        {bank.name}
                      </div>
                    ))}
                  </div>
                </>
              )}
            </div>
            <input
              type="text"
              style={{ ...inputStyle, width: "100%", marginBottom: "20px" }}
              placeholder={t('commission.enterBankAccount', { defaultValue: 'Bank Account Number' })}
              value={bankAccountNumber}
              onChange={(e) => setBankAccountNumber(e.target.value)}
              disabled={bankSubmitLoading}
            />
            <div style={confirmCancelRowStyle}>
              <button
                style={{ ...horizontalButtonStyle, opacity: bankSubmitLoading ? 0.6 : 1 }}
                onClick={handleRegisterBank}
                disabled={bankSubmitLoading}
              >
                {bankSubmitLoading ? t('commission.processing') : t('commission.confirm')}
              </button>
              <button
                style={horizontalButtonStyle}
                onClick={closeBankModal}
                disabled={bankSubmitLoading}
              >
                {t('commission.cancel')}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Commission;